import classnames from "classnames";
import { useState } from "react";
import { Loading, ModalDeleteIcon } from "components/assets/Icons";
import Button, { SIZE as VIEW, COLOR } from "components/Button";
import styles from "./Modals.module.scss";
import userProfile from "services/user.profile";

export const ModalDelete = ({
  data,
  setShowModal,
  scheduleName,
  setIsRefresh,
  setMessage,
  setShowMessage,
}) => {
  const [loading, setLoading] = useState(false);

  const handleOnClick = (e) => {
    e.preventDefault();
    setLoading(true);

    const removeSchedule = async (id) => {
      try {
        const response = await userProfile.deleteSchedule(id);

        if (response.status === 204) {
          setMessage(`Schedule "${scheduleName}" successfully deleted`);
          setTimeout(() => setShowMessage(true), 900);
          setTimeout(() => setShowMessage(false), 2900);
        }
      } catch (error) {
        console.error("error >>:", error);
      } finally {
        setLoading(false);
      }
    };

    removeSchedule(data);

    setTimeout(() => {
      setIsRefresh((prevRefresh) => !prevRefresh);
      setShowModal(false);
    }, 500);
  };

  return (
    <div className={classnames(styles.content, styles.delete_content)}>
      <ModalDeleteIcon />
      <h2 className={styles.title}>
        Delete Schedule <span className={styles.delScheduleName}>'{scheduleName}'</span>
      </h2>
      <p className={styles.description}>
        Do you really want to delete this schedule? This process cannot be undone.
      </p>
      <div className={styles.group}>
        <Button size={VIEW.MIDDLE} color={COLOR.NONE} onClick={() => setShowModal(false)}>
          Cancel
        </Button>
        <Button size={VIEW.MIDDLE} onClick={handleOnClick}>
          {loading ? <Loading /> : "Delete"}
        </Button>
      </div>
    </div>
  );
};
